module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01-m.942327d539948c040e13a5642ba4041f.png";